export default "__VITE_ASSET__BCMN9S6C__"